import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import { BUS_ASSIGNMENT_SCHEDULE_PATH } from '../../../../config/paths';
import EditButton from '../../../common/button/EditButton';
import BusAssignmentScheduleDeleteButton from './BusAssignmentScheduleDeleteButton';

const BusAssignmentScheduleToolbar = ({ busAssignmentScheduleId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${BUS_ASSIGNMENT_SCHEDULE_PATH}/${busAssignmentScheduleId}/edit`}
      />{' '}
      <BusAssignmentScheduleDeleteButton
        busAssignmentScheduleId={busAssignmentScheduleId}
      />
    </div>
  </ButtonToolbar>
);

BusAssignmentScheduleToolbar.propTypes = {
  busAssignmentScheduleId: PropTypes.number.isRequired,
};

export default BusAssignmentScheduleToolbar;
